import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chats" }
const _hoisted_2 = { class: "chat-container" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($data.chat)
        ? (_openBlock(), _createBlock($setup["Chat"], {
            key: 0,
            class: "chat",
            chat: $data.chat
          }, null, 8 /* PROPS */, ["chat"]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}